import {
  Controller,
  FieldErrors,
  Control,
  FieldErrorsImpl,
  FieldError,
  Merge,
} from "react-hook-form";
import TextField from "@mui/material/TextField";
import { FocusEvent } from "react";
import { Theme } from "@emotion/react";
import { SxProps } from "@mui/material";
import { getTextAfterLastDot } from "../utils/utils";
import { forwardRef } from "react";
import { InputMask, type InputMaskProps } from "@react-input/mask";

const ForwardedInputMask = forwardRef<HTMLInputElement, InputMaskProps>(
  (props, forwardedRef) => {
    return (
      <InputMask
        ref={forwardedRef}
        mask={"+55 (nn) nnnnn-nnnn"}
        replacement={{ n: /\d/ }}
        {...props}
      />
    );
  }
);

export default function PhoneNumberInput(props: {
  fieldName: string;
  label: string;
  errors:
    | FieldErrors<any>
    | FieldErrorsImpl<any>
    | Merge<FieldError, FieldErrorsImpl<any>>
    | undefined;
  fontSize?: number;
  disabled?: boolean;
  isFromArray?: boolean;
  control: Control<any, any>;
  type?: string;
  width?: number | string;
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
  style?: React.CSSProperties;
  required?: boolean;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
}) {
  const { fieldName, control, fontSize, errors, label, disabled, isFromArray } =
    props;

  const errorKey = isFromArray ? getTextAfterLastDot(fieldName) : fieldName;

  const errorMessage = (errors &&
    (typeof errors[errorKey]?.message === "string"
      ? errors[errorKey]?.message
      : undefined)) as string | undefined;

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <TextField
          disabled={disabled}
          style={props.style}
          size="small"
          sx={{
            ...props.sx,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
            },
          }}
          InputProps={{
            style: {
              fontSize: fontSize ?? 14,
            },
            inputComponent: ForwardedInputMask,
          }}
          InputLabelProps={{
            style: { fontSize: fontSize ?? 14 },
          }}
          value={field.value ?? ""}
          onChange={(e) => {
            field.onChange(e);
          }}
          type={props.type ?? "text"}
          label={label}
          error={
            !isFromArray
              ? errors && !!errors[fieldName]
              : errorMessage
              ? true
              : false
          }
          helperText={errorMessage}
          required={props.required}
          onBlur={props.onBlur}
        />
      )}
    />
  );
}
